import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { PatientStore } from "@/Patient/Stores/PatientStore";

export class PatientHistoryPortalCommunicationsHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalPatientOperations.History.PortalCommunicationsSetCurrentThread, this.setCurrentPatientThread);
    }

    private setCurrentPatientThread(request: LocalEvent, store: PatientStore): void {
        store.patientHistoryPortalCommunicationsCurrentThread[store.getCurrentPatientContactId()] = request.Get<string>("sharedItemId");
    }
}
